import React, { useState, useEffect, useRef } from 'react';
import 'katex/dist/katex.min.css';
import katex from 'katex';
import html2pdf from 'html2pdf.js';
import TypewriterRendererExample from './TypeWriterExample';
import TypewriterRenderer from './TypeWriterRender';
import TypewriterRendererResponse from './TypeWriterResponse';
import LatexGenerator from './topicSelectorComponents/LectureNotesGenerator';
import SlidesGenerator from './topicSelectorComponents/SlidesGenerator';
import LectureSlides from './topicSelectorComponents/VirtualClassroom';

const currentUrl = window.location.href;
const ipAddress = currentUrl.split(':')[1].split('/')[2];



function TopicSelector() {
    const [subjects, setSubjects] = useState([]);
    const [textbooks, setTextbooks] = useState([]);
    const [chapters, setChapters] = useState([]);
    const [topics, setTopics] = useState([]);
    const [questions, setQuestions] = useState([]);

    const [selectedSubject, setSelectedSubject] = useState('');
    const [selectedTextbook, setSelectedTextbook] = useState('');
    const [selectedChapter, setSelectedChapter] = useState('');
    const [selectedTopic, setSelectedTopic] = useState('');
    const [selectedQuestion, setSelectedQuestion] = useState('');

    const [chapterSummary, setChapterSummary] = useState('');
    const [topicSummary, setTopicSummary] = useState('');
    const [questionSolution, setQuestionSolution] = useState('');
    const [userQuestion, setUserQuestion] = useState('');
    const [response, setResponse] = useState('Hello! How may I help you today?');
    const [responseEquations, setResponseEquations] = useState('');
    const [responseExample, setResponseExample] = useState('');


    const [showChapterSummary, setShowChapterSummary] = useState(false);
    const [showTopicSummary, setShowTopicSummary] = useState(false);
    const [showQuestionSolution, setShowQuestionSolution] = useState(false);


    const [showPDFModal, setShowPDFModal] = useState(false); // State for controlling the modal visibility

    const [showVirtualClassroomPopup, setShowVirtualClassroomPopup] = useState(false);

    const [showLecturePopup, setShowLecturePopup] = useState(false);
    const [showSlidesPopup, setShowSlidesPopup] = useState(false);

    const [lectureLatexCodeSent, setLectureLatexCodeSent] = useState("");
    const [slidesLatexCodeSent, setSlidesLatexCodeSent] = useState("");


    window.handleEquationQuestion = async (equation, action) => {
        try {
            setResponse('');
            setResponseEquations('');
            setResponseExample('');
            const res = await fetch('/api/query-equation', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    equation,
                    action, // "what" or "how"
                }),
            });

            const data = await res.json();
            setResponseEquations(data.responseEquations);
/*             console.log(data.responseEquations);  // Do something with the response
 */        } catch (error) {
            console.error('Error:', error);
        }

    };



    window.handleExampleQuestion = async (questionpart) => {
        try {
            setResponse('');
            setResponseEquations('');
            setResponseExample('');
            const res = await fetch('/api/query-example', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    example: questionpart,
                    questionSolution: questionSolution,
                }),
            });

            const data = await res.json();
            setResponseExample(data.responseExample);
/*             console.log(data.responseEquations);  // Do something with the response
 */        } catch (error) {
            console.error('Error:', error);
        }

    };


    useEffect(() => {
        // Fetch subjects using the fetch API
        fetch(`/api/subjects`)
            .then((response) => response.json())
            .then((data) => setSubjects(data))
            .catch((error) => console.error('Error fetching subjects:', error));
    }, []);

    const handleSubjectChange = (subjectId) => {

        setSelectedSubject(subjectId);
        setTextbooks([]);
        setChapters([]);
        setTopics([]);
        setQuestions([]);
        // Fetch textbooks based on subjectId
        fetch(`/api/textbooks/${subjectId}`)
            .then((response) => response.json())
            .then((data) => setTextbooks(data))
            .catch((error) => console.error('Error fetching textbooks:', error));
    };

    const handleTextbookChange = (textbookId) => {
        setSelectedTextbook(textbookId);
        setChapters([]);
        setTopics([]);
        setQuestions([]);
        // Fetch chapters based on textbookId
        fetch(`/api/chapters/${textbookId}`)
            .then((response) => response.json())
            .then((data) => setChapters(data))
            .catch((error) => console.error('Error fetching chapters:', error));
    };

    const handleChapterChange = (chapterId) => {
        setSelectedChapter(chapterId);
        // Fetch chapter summary
        fetch(`/api/chapter-summary/${chapterId}`)
            .then((response) => response.json())
            .then((data) => setChapterSummary(data.summary))
            .catch((error) => console.error('Error fetching chapter summary:', error));

        // Fetch topics based on chapterId
        fetch(`/api/topics/${chapterId}`)
            .then((response) => response.json())
            .then((data) => setTopics(data))
            .catch((error) => console.error('Error fetching topics:', error));
    };

    const handleTopicChange = (topicId) => {
        setSelectedTopic(topicId);
        // Fetch topic summary
        fetch(`/api/topic-summary/${topicId}`)
            .then((response) => response.json())
            .then((data) => setTopicSummary(data.summary))
            .catch((error) => console.error('Error fetching topic summary:', error));

        // Fetch questions based on topicId
        fetch(`/api/questions/${topicId}`)
            .then((response) => response.json())
            .then((data) => setQuestions(data))
            .catch((error) => console.error('Error fetching questions:', error));
    };




    const handleQuestionChange = (questionId) => {
        setSelectedQuestion(questionId);
        // Fetch question and solution
        fetch(`/api/question/${questionId}`)
            .then((response) => response.json())
            .then((data) => setQuestionSolution(data.solution))
            .catch((error) => console.error('Error fetching question solution:', error));
    };

    /*     console.log('html on render:', renderContentWithLatex(latexCode)); */


    let latexCodeSent = ''; // Declare latexCodeSent outside the conditions

    if (showChapterSummary) {
        latexCodeSent = chapterSummary;
    } else if (showTopicSummary) {
        latexCodeSent = topicSummary;
    } else if (showQuestionSolution) {
        latexCodeSent = questionSolution;
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setResponse('');
        setResponseEquations('');
        try {
            const res = await fetch('/api/course-question', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    question: userQuestion,
                    latexCode: latexCodeSent,
                })
            });
            const data = await res.json();
            setResponse(data.response);
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const chapterPdfContentRef = useRef();
    const generateChapterPDF = () => {
        const element = chapterPdfContentRef.current; // Get the rendered HTML content
        const options = {
            filename: 'chaptersummary.pdf',
            margin: [20, 20], // Adjust margin
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            html2canvas: {
                backgroundColor: 'white', // Ensure the background is white
                ignoreElements: (el) => el.tagName === 'BUTTON', // Ignore buttons and other unwanted elements
                letterRendering: true, // Improve font rendering
            },
            pagebreak: { mode: ['avoid-all', 'css'] }, // Better control over page breaks
        };

        // Generate the PDF from the HTML content
        html2pdf().from(element).set(options).save();

        // Show the modal after PDF generation
        setShowPDFModal(true);
    };

    const topicPdfContentRef = useRef();
    const generateTopicPDF = () => {
        const element = topicPdfContentRef.current; // Get the rendered HTML content
        const options = {
            filename: 'topicsummary.pdf',
            margin: [20, 20], // Adjust margin
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            html2canvas: {
                backgroundColor: 'white', // Ensure the background is white
                ignoreElements: (el) => el.tagName === 'BUTTON', // Ignore buttons and other unwanted elements
                letterRendering: true, // Improve font rendering
            },
            pagebreak: { mode: ['avoid-all', 'css'] }, // Better control over page breaks
        };

        // Generate the PDF from the HTML content
        html2pdf().from(element).set(options).save();

        // Show the modal after PDF generation
        setShowPDFModal(true);
    };
    const questionPdfContentRef = useRef();
    const generateQuestionPDF = () => {
        const element = questionPdfContentRef.current; // Get the rendered HTML content
        const options = {
            filename: 'question.pdf',
            margin: [20, 20], // Adjust margin
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            html2canvas: {
                backgroundColor: 'white', // Ensure the background is white
                ignoreElements: (el) => el.tagName === 'BUTTON', // Ignore buttons and other unwanted elements
                letterRendering: true, // Improve font rendering
            },
            pagebreak: { mode: ['avoid-all', 'css'] }, // Better control over page breaks
        };

        // Generate the PDF from the HTML content
        html2pdf().from(element).set(options).save();

        // Show the modal after PDF generation
        setShowPDFModal(true);
    };

    return (

        <div style={styles.container}>
            <div style={styles.left}>
                <div>
                    <h1 className="text-white text-2xl text-center font-bold font-sans tracking-wide bg-gradient-to-r from-pink-400 to-purple-500 bg-clip-text text-transparent drop-shadow-lg py-6">
                        Select Chapters, Topics or Questions to Show More Functions
                    </h1>



                    <div className="relative py-8 rounded-lg border-blue-100 shadow-lg">
                        {/* Background with Gradient & Subtle Pattern */}
                        <div className="absolute inset-0 bg-gradient-to-br rounded-lg from-blue-900 to-gray-800 opacity-95"></div>
                        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/hexellence.png')] opacity-10"></div>
                        <div className="relative grid grid-cols-1 md:grid-cols-2 gap-3 items-center justify-center w-full max-w-3xl mx-auto bg-white bg-opacity-0 rounded-lg p-3">
                            {/* Subject Selection */}
                            <div className="flex flex-col items-left space-y-2">
                                <select
                                    className="w-100 h-12 p-3 text-lg bg-gray-900 text-white border border-gray-700 rounded-lg shadow-md focus:ring-2 focus:ring-red-500 focus:outline-none transition-all duration-300"
                                    value={selectedSubject}
                                    onChange={(e) => handleSubjectChange(e.target.value)}
                                >
                                    <option value="">Select Subject</option>
                                    {subjects.map((subject) => (
                                        <option key={subject.id} value={subject.id}>{subject.name}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Textbook Selection */}
                            <div className="flex flex-col items-left space-y-2">
                                <select
                                    className="w-100 h-12 p-3 text-lg bg-gray-900 text-white border border-gray-700 rounded-lg shadow-md focus:ring-2 focus:ring-red-500 focus:outline-none transition-all duration-300"
                                    value={selectedTextbook}
                                    onChange={(e) => handleTextbookChange(e.target.value)}
                                    disabled={!selectedSubject}
                                >
                                    <option value="">Select Textbook</option>
                                    {textbooks.map((textbook) => (
                                        <option key={textbook.id} value={textbook.id}>{textbook.name}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Chapter Selection & Button */}
                            <div className="flex items-center justify-between space-x-3">
                                <select
                                    className="w-80 h-12 p-3 text-lg bg-gray-900 text-white border border-gray-700 rounded-lg shadow-md focus:ring-2 focus:ring-red-500 focus:outline-none transition-all duration-300"
                                    value={selectedChapter}
                                    onChange={(e) => handleChapterChange(e.target.value)}
                                    disabled={!selectedTextbook}
                                >
                                    <option value="">Select Chapter</option>
                                    {chapters.map((chapter) => (
                                        <option key={chapter.id} value={chapter.id}>{chapter.name}</option>
                                    ))}
                                </select>

                                <button
                                    className="w-30 h-12 px-4 bg-red-700 text-white rounded-lg shadow-md hover:bg-red-800 transition-all duration-300 disabled:bg-gray-600 disabled:cursor-not-allowed flex items-center justify-center"
                                    onClick={() => {
                                        setShowChapterSummary(true);
                                        setShowTopicSummary(false);
                                        setShowQuestionSolution(false);
                                    }}
                                    disabled={!selectedChapter}
                                >
                                    Show Chapter
                                </button>
                            </div>

                            {/* Topic Selection & Button */}
                            <div className="flex items-center justify-between space-x-3">
                                <select
                                    className="w-80 h-12 p-3 text-lg bg-gray-900 text-white border border-gray-700 rounded-lg shadow-md focus:ring-2 focus:ring-red-500 focus:outline-none transition-all duration-300"
                                    value={selectedTopic}
                                    onChange={(e) => handleTopicChange(e.target.value)}
                                    disabled={!selectedChapter}
                                >
                                    <option value="">Select Topic</option>
                                    {topics.map((topic) => (
                                        <option key={topic.id} value={topic.id}>{topic.name}</option>
                                    ))}
                                </select>

                                <button
                                    className="w-30 h-12 px-4 bg-red-700 text-white rounded-lg shadow-md hover:bg-red-800 transition-all duration-300 disabled:bg-gray-600 disabled:cursor-not-allowed flex items-center justify-center"
                                    onClick={() => {
                                        setShowChapterSummary(false);
                                        setShowTopicSummary(true);
                                        setShowQuestionSolution(false);
                                    }}
                                    disabled={!selectedTopic}
                                >
                                    Show Topic
                                </button>
                            </div>

                            {/* Question Selection & Button */}
                            <div className="flex items-center justify-between space-x-3">
                                <select
                                    className="w-80 h-12 p-3 text-lg bg-gray-900 text-white border border-gray-700 rounded-lg shadow-md focus:ring-2 focus:ring-red-500 focus:outline-none transition-all duration-300"
                                    value={selectedQuestion}
                                    onChange={(e) => handleQuestionChange(e.target.value)}
                                    disabled={!selectedTopic}
                                >
                                    <option value="">Select Question</option>
                                    {questions.map((question) => (
                                        <option key={question.id} value={question.id}>{question.question}</option>
                                    ))}
                                </select>

                                <button
                                    className="w-30 h-12 px-4 bg-red-700 text-white rounded-lg shadow-md hover:bg-red-800 transition-all duration-300 disabled:bg-gray-600 disabled:cursor-not-allowed flex items-center justify-center"
                                    onClick={() => {
                                        setShowChapterSummary(false);
                                        setShowTopicSummary(false);
                                        setShowQuestionSolution(true);
                                    }}
                                    disabled={!selectedQuestion}
                                >
                                    Show Solution
                                </button>
                            </div>

                            {/* Virtual Classroom Button */}
                            {(showChapterSummary || showQuestionSolution || showTopicSummary) && (
                                <div className="col-span-2 flex justify-center">
                                    <button
                                        className="w-128 h-14 bg-gradient-to-r from-purple-400 to-purple-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-200 hover:to-blue-500 transition-all duration-300 flex items-center justify-center"
                                        onClick={() => {
                                            setLectureLatexCodeSent(latexCodeSent);
                                            setShowVirtualClassroomPopup(true);
                                        }}
                                    >
                                        Virtual Classroom
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>


                    {showVirtualClassroomPopup && (
                        <LectureSlides
                            material={lectureLatexCodeSent}
                        />
                    )}
                    {/* Display Chapter Summary */}
                    {showChapterSummary && chapterSummary && (

                        <div>
                            <div className="flex flex-wrap justify-center gap-4 mt-6">
                                {/* Download as PDF Button */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={generateChapterPDF}
                                    disabled={!showChapterSummary}
                                >
                                    📄 Download as PDF
                                </button>

                                {/* Open Lecture Notes Generator */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={() => { setLectureLatexCodeSent(latexCodeSent); setShowLecturePopup(true); }}
                                >
                                    📚 Open Lecture Notes Generator
                                </button>

                                {/* Open Slides Generator */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={() => { setSlidesLatexCodeSent(latexCodeSent); setShowSlidesPopup(true); }}
                                >
                                    📊 Open Slides Generator
                                </button>
                            </div>


                            <h1 style={{
                                color: 'white',            // Use camelCase for CSS properties
                                fontSize: '24px',         // font-size becomes fontSize
                                textAlign: 'center',      // text-align becomes textAlign
                                fontFamily: 'Segoe UI, sans-serif',  // font-family becomes fontFamily
                                fontWeight: 'lighter',        // Bold text
                                fontStyle: 'normal',       // Italic text
                            }}>
                                Chapter Summary
                            </h1>
                            <div ref={chapterPdfContentRef}>
                                <TypewriterRenderer content={chapterSummary} />
                            </div>
                            {showLecturePopup && (
                                <LatexGenerator
                                    latexCodeSent={lectureLatexCodeSent}
                                    onClose={() => setShowLecturePopup(false)}
                                />
                            )}
                            {showLecturePopup && <div className="blur-background"></div>}
                            {showSlidesPopup && (
                                <SlidesGenerator
                                    latexCodeSent={slidesLatexCodeSent}
                                    onClose={() => setShowSlidesPopup(false)}

                                />
                            )}
                            {showSlidesPopup && <div className="blur-background"></div>}
                            {showPDFModal && (
                                <div className="pdf-modal-overlay">
                                    <div className="pdf-modal-content">
                                        <h2>PDF Generated!</h2>
                                        <p>Your PDF is ready for download.</p>
                                        <button onClick={() => setShowPDFModal(false)}>Close</button>
                                    </div>
                                </div>
                            )}

                            {/* Optional: Add a blur effect to the background when the modal is shown */}
                            {showPDFModal && <div className="blur-background"></div>}
                        </div>
                    )}

                    {/* Display Topic Summary */}
                    {showTopicSummary && topicSummary && (

                        <div>
                            <div className="flex flex-wrap justify-center gap-4 mt-6">
                                {/* Download as PDF Button */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={generateChapterPDF}
                                    disabled={!showTopicSummary}
                                >
                                    📄 Download as PDF
                                </button>

                                {/* Open Lecture Notes Generator */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={() => { setLectureLatexCodeSent(latexCodeSent); setShowLecturePopup(true); }}
                                >
                                    📚 Open Lecture Notes Generator
                                </button>

                                {/* Open Slides Generator */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={() => { setSlidesLatexCodeSent(latexCodeSent); setShowSlidesPopup(true); }}
                                >
                                    📊 Open Slides Generator
                                </button>
                            </div>
                            <h1 style={{
                                color: 'white',            // Use camelCase for CSS properties
                                fontSize: '24px',         // font-size becomes fontSize
                                textAlign: 'center',      // text-align becomes textAlign
                                fontFamily: 'Segoe UI, sans-serif',  // font-family becomes fontFamily
                                fontWeight: 'lighter',        // Bold text
                                fontStyle: 'normal',       // Italic text
                            }}>
                                Topic Summary
                            </h1>
                            <div ref={topicPdfContentRef}>
                                <TypewriterRendererResponse content={topicSummary} />
                            </div>
                            {showLecturePopup && (
                                <LatexGenerator
                                    latexCodeSent={lectureLatexCodeSent}
                                    onClose={() => setShowLecturePopup(false)}
                                />
                            )}
                            {showLecturePopup && <div className="blur-background"></div>}
                            {showPDFModal && (
                                <div className="pdf-modal-overlay">
                                    <div className="pdf-modal-content">
                                        <h2>PDF Generated!</h2>
                                        <p>Your PDF is ready for download.</p>
                                        <button onClick={() => setShowPDFModal(false)}>Close</button>
                                    </div>
                                </div>
                            )}

                            {/* Optional: Add a blur effect to the background when the modal is shown */}
                            {showPDFModal && <div className="blur-background"></div>}
                        </div>
                    )}

                    {/* Display Question Solution */}
                    {showQuestionSolution && questionSolution && (
                        <div>
                            <div className="flex flex-wrap justify-center gap-4 mt-6">
                                {/* Download as PDF Button */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={generateChapterPDF}
                                    disabled={!showQuestionSolution}
                                >
                                    📄 Download as PDF
                                </button>

                                {/* Open Lecture Notes Generator */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={() => { setLectureLatexCodeSent(latexCodeSent); setShowLecturePopup(true); }}
                                >
                                    📚 Open Lecture Notes Generator
                                </button>

                                {/* Open Slides Generator */}
                                <button
                                    className="w-72 h-14 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 flex items-center justify-center"
                                    onClick={() => { setSlidesLatexCodeSent(latexCodeSent); setShowSlidesPopup(true); }}
                                >
                                    📊 Open Slides Generator
                                </button>
                            </div>
                            <h1 style={{
                                color: 'white',            // Use camelCase for CSS properties
                                fontSize: '24px',         // font-size becomes fontSize
                                textAlign: 'center',      // text-align becomes textAlign
                                fontFamily: 'Segoe UI, sans-serif',  // font-family becomes fontFamily
                                fontWeight: 'lighter',        // Bold text
                                fontStyle: 'normal',       // Italic text
                            }}>
                                Question and Solution
                            </h1>
                            <div ref={questionPdfContentRef}>
                                <TypewriterRendererExample content={questionSolution} />
                            </div>
                            {showLecturePopup && (
                                <LatexGenerator
                                    latexCodeSent={lectureLatexCodeSent}
                                    onClose={() => setShowLecturePopup(false)}
                                />
                            )}
                            {showLecturePopup && <div className="blur-background"></div>}
                            {showPDFModal && (
                                <div className="pdf-modal-overlay">
                                    <div className="pdf-modal-content">
                                        <h2>PDF Generated!</h2>
                                        <p>Your PDF is ready for download.</p>
                                        <button onClick={() => setShowPDFModal(false)}>Close</button>
                                    </div>
                                </div>
                            )}

                            {/* Optional: Add a blur effect to the background when the modal is shown */}
                            {showPDFModal && <div className="blur-background"></div>}
                        </div>
                    )}
                    <div></div>

                </div>

            </div>
            <div style={styles.right}>
            <h1 className="text-white text-2xl text-center font-bold font-sans tracking-wide bg-gradient-to-r from-pink-400 to-purple-500 bg-clip-text text-transparent drop-shadow-lg py-6">
                        Have A Question? Feel Free to Ask
                    </h1>
                <div className="flex justify-center items-center w-full">
                    <div  className="w-full max-w-[45vw] relative">
                        <div className="relative z-0">
                            <textarea
                                id="question"
                                className="w-full p-4 border border-gray-300 rounded-2xl shadow-md focus:ring-2 focus:ring-blue-500 focus:outline-none text-gray-800 resize-none bg-white dark:bg-gray-800 dark:text-white dark:border-gray-700"
                                value={userQuestion}
                                onChange={(e) => setUserQuestion(e.target.value)}
                                rows="4"
                                placeholder="Type your question..."
                            />
                            <button
                                type="submit"
                                onClick={handleSubmit}
                                className="absolute min-w-[5vw] bottom-4 right-4 bg-blue-500 hover:bg-blue-600 text-white font-bold p-3 rounded-full shadow-lg transition-all z-10"
                            >
                                &#9658;
                            </button>
                        </div>
                    </div>
                </div>


                {!response && !responseEquations && !responseExample && (
                    <div
                        id="loading-animation"
                        className="loading-animation"
                        style={{ display: response ? 'none' : 'inline-block' }} // Dynamically control visibility
                    >
                        <span className="dot">.</span>
                        <span className="dot">.</span>
                        <span className="dot">.</span>
                    </div>
                )}
                {response && (
                    <div>
                        <h1 style={{
                            color: 'white',            // Use camelCase for CSS properties
                            fontSize: '16px',         // font-size becomes fontSize
                            textAlign: 'center',      // text-align becomes textAlign
                            fontFamily: 'Segoe UI, sans-serif',  // font-family becomes fontFamily
                            fontWeight: 'lighter',        // Bold text
                            fontStyle: 'normal',       // Italic text
                        }}>
                            Response from Ai Solver
                        </h1>
                        <div>
                            <TypewriterRenderer content={response} />
                        </div>
                    </div>

                )}

                {responseEquations && (
                    <div>
                        <h1 style={{
                            color: 'white',            // Use camelCase for CSS properties
                            fontSize: '24px',         // font-size becomes fontSize
                            textAlign: 'center',      // text-align becomes textAlign
                            fontFamily: 'Segoe UI, sans-serif',  // font-family becomes fontFamily
                            fontWeight: 'lighter',        // Bold text
                            fontStyle: 'normal',       // Italic text
                        }}>
                            Response from Ai Solver
                        </h1>
                        <div>
                            <TypewriterRendererResponse content={responseEquations} />
                        </div>
                    </div>

                )}

                {responseExample && (
                    <div>
                        <h1 style={{
                            color: 'white',            // Use camelCase for CSS properties
                            fontSize: '24px',         // font-size becomes fontSize
                            textAlign: 'center',      // text-align becomes textAlign
                            fontFamily: 'Segoe UI, sans-serif',  // font-family becomes fontFamily
                            fontWeight: 'lighter',        // Bold text
                            fontStyle: 'normal',       // Italic text
                        }}>
                            Response from Ai Solver
                        </h1>
                        <div>
                            <TypewriterRendererResponse content={responseExample} />
                        </div>
                    </div>

                )}
            </div>

        </div>
    );

}

const styles = {
    container: {
        display: 'flex',
        height: '100vh',
        justifyContent: 'space-between',
        padding: '0px',
        borderRadius: '0px',
        overflow: 'hidden',
        width: '101vw',
        background: '#f5f5f5',  // Neutral background color to make sections stand out
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',  // Soft shadow for depth
    },
    left: {
        flex: 1,
        width: '50%',
        background: 'linear-gradient(90deg,rgb(22, 24, 45),rgb(22, 24, 45))',  // Gradient background for left column
        padding: '0px',
        borderRadius: '0px',
        overflow: 'auto',
        border: '0px solid rgba(255, 255, 255, 0.3)',
        margin: '0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    right: {
        flex: 1,
        width: '50%',
        background: 'linear-gradient(90deg,rgb(22, 24, 45),rgb(22, 24, 45))',  // Gradient background for left column
        padding: '0px',  // Fix top edge spacing issue
        borderRadius: '0px',
        overflow: 'auto',
        border: '0px solid rgba(255, 255, 255, 0.3)',
        margin: '0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
};


export default TopicSelector;
